export default "__VITE_PUBLIC_ASSET__8ed885e8__"